var React = require('react');

function Arrow01 (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:#fff;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:30px;}")),React.createElement("polyline",{"className":"cls-1","points":"100 298.85 502.3 701.15 900 303.44","key":1})]);
}

Arrow01.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 1000 1000"};

module.exports = Arrow01;

Arrow01.default = Arrow01;
